import React from 'react';

export default function NoNotificationIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <g clipPath="url(#clip0_24_55062)">
        <path
          d="M12.3497 4C11.6495 3.99979 10.9561 4.13756 10.3091 4.40544C9.66209 4.67331 9.07422 5.06605 8.57907 5.5612C8.08392 6.05635 7.69118 6.64422 7.42331 7.29121C7.15543 7.93819 7.01766 8.63163 7.01787 9.33188V11.0131C6.99243 11.6522 6.81983 12.2769 6.5135 12.8384L5.49676 14.5357C4.77624 15.5612 4.64174 17.236 6.45746 17.1376C12.0936 17.2376 13.4554 17.1536 18.25 17.1376C20.0666 17.0783 20.2275 16.112 19.2107 14.5357L18.194 12.8384C17.8887 12.2765 17.7161 11.6521 17.6896 11.0131V9.33188C17.6812 7.91899 17.1157 6.56648 16.1158 5.56815C15.116 4.56982 13.7626 4.0063 12.3497 4Z"
          stroke={props.stroke ?? '#909090'}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M15.0047 17.4658C15.0022 18.1721 14.7205 18.8487 14.2211 19.3481C13.7217 19.8475 13.0451 20.1292 12.3388 20.1318C11.6326 20.1293 10.9562 19.8472 10.4574 19.3472C9.95745 18.8485 9.67536 18.172 9.67285 17.4658"
          stroke={props.stroke ?? '#909090'}
          strokeWidth="1.2"
        />
        <path
          d="M5.37191 0.829343C5.0015 0.347813 4.31087 0.257731 3.82934 0.628138C3.34781 0.998546 3.25773 1.68918 3.62814 2.17071L18.6281 21.6707C18.9985 22.1522 19.6892 22.2423 20.1707 21.8719C20.6522 21.5015 20.7423 20.8109 20.3719 20.3293L5.37191 0.829343Z"
          fill={props.fill ?? '#909090'}
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24_55062">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
